import React, { useEffect } from "react";
import { Button, Row, Col, Space, Typography } from "antd";
import { AppleOutlined, AndroidOutlined } from "@ant-design/icons"; // Ant Design icons for platforms
import { isPlatform } from "@ionic/react";
import metaData from "../data/metaData";

const { Text } = Typography;

const DownloadApp = () => {
  useEffect(() => {
    if (isPlatform("ios")) {
      // Redirect to Apple App Store
      console.log("redirect to apple store");
      window.location.href = metaData.offical.appleStore;
    } else if (isPlatform("android")) {
      // Redirect to Google Play Store
      console.log("redirect to google store");
      window.location.href = metaData.offical.androidStore;
    }
  }, []);

  return (
    <Row justify="center" style={{ marginTop: "2rem" }}>
      {isPlatform("ios") ? (
        "redirecting to apple store"
      ) : true ? (
        "redirecting to google store"
      ) : (
        // <Space direction="vertical" style={{ marginTop: "35vh" }}>
        //   <Row justify="center">
        //     <img
        //       style={{
        //         width: "75px",
        //         height: "75px",
        //         borderRadius: "5px",
        //       }}
        //       src={metaData.blobPreURL + metaData.appLogoPath + metaData.blobPostURL}
        //     />
        //   </Row>
        //   <Text strong style={{ fontSize: "1.25rem" }}>
        //     Android app is coming soon
        //   </Text>
        // </Space>
        <Row justify="center" style={{ marginTop: "2rem" }} gutter={[16, 16]}>
          <Col>
            <Button
              size="large"
              shape="round"
              icon={<AppleOutlined />}
              style={{ border: "1px solid black", padding: "0.5rem" }}
              onClick={() => (window.location.href = metaData.offical.appleStore)}
            >
              Download on the App Store
            </Button>
          </Col>
          <Col>
            <Button
              size="large"
              shape="round"
              disabled
              icon={<AndroidOutlined />}
              style={{ border: "1px solid black", padding: "0.5rem" }}
              onClick={() => (window.location.href = metaData.offical.androidStore)}
            >
              Get it on Google Play
            </Button>
          </Col>
        </Row>
      )}
    </Row>
  );
};

export default DownloadApp;
